export const type = {
  sans: '\'SF Pro\', ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif',
  mono: '\'SF Mono\', SFMono-Regular, ui-monospace, \'DejaVu Sans Mono\', Menlo, Consolas, monospace'
}